// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from 'element-ui'
import {Loading} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'
import VueAxios from 'vue-axios'
import $ from '../static/js/jquery-1.11.3.js'

Vue.prototype.$ = $;
Vue.prototype.Loading = Loading;
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.use(VueAxios, Axios);

router.beforeEach((to, from, next) => {
  next();

  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js